// | ------------------------------------------------------------------------
// | Imports
// | ------------------------------------------------------------------------

// Bootstrap ----------------------------------------------------------------

//import "@popperjs/core"; // Popper is required for dropdowns, popovers and tooltips.
import {
  Alert,
  Button,
  //Carousel,
  Collapse,
  //Dropdown,
  Modal,
  OffCanvas,
  //Popover,
  //ScrollSpy,
  //Tab,
  //Toast,
  //Tooltip,
} from "bootstrap";

// Bootstrap overrides, calls and template integration
import "./bootstrap/collapse";
import "./bootstrap/modals";
import "./bootstrap/offcanvas";
//import "./bootstrap/popovers";
//import "./bootstrap/tooltips";

// Imports used in shop components ------------------------------------------

//? https://kingsora.github.io/OverlayScrollbars/
import { OverlayScrollbars } from "overlayscrollbars"; // Used in /components/shop/productFilters

//? https://splidejs.com/
import Splide from "@splidejs/splide"; // Used in /components/shop/productGallery

//? https://github.com/biati-digital/glightbox
import GLightbox from "glightbox/dist/js/glightbox.js"; // Used in /components/shop/productGallery

// Other imports ------------------------------------------------------------

//? https://github.com/michalsnik/aos
//import AOS from "aos"; // Used in /components/animateOnScroll

//? https://simpleparallax.com/
//import simpleParallax from "simple-parallax-js"; // Used in /components/parallaxSections

//? https://github.com/yowainwright/shav
//import shave from "shave"; // Used in /components/ellipsis

// | ------------------------------------------------------------------------
// | Components
// | ------------------------------------------------------------------------

// Cookie popup
import "./components/cookiePopup";

// | Layout -----------------------------------------------------------------

import "./components/fixedHeader";

// | Navigation -------------------------------------------------------------

import "./components/mainNavigation";
//import "./components/dropdownOnHover";
import "./components/scrollLinks";

// | Content ----------------------------------------------------------------

import "./components/modernizr-webp"; // Allow background images to fallback to jpegs
//import "./components/ellipsis"; // Allows us to restrict text content using ellipsis

// | Animations -------------------------------------------------------------

//import "./components/animateOnScroll"; // Animate elements on page scroll
import "./components/heroParallaxBlur"; // Parallax, blur and fade hero background image on scroll
//import "./components/parallaxSections"; // Parallax backgrounds for page sections

// | Shop specific ----------------------------------------------------------

//import "./components/shop/productFilters";
//import "./components/shop/productGallery";
//import "./components/shop/productGrid";
//import "./components/shop/quantityInputs";

import "./components/forms";
import "./components/map";

// | ------------------------------------------------------------------------
// | Code
// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {

		var lightbox = GLightbox({
			touchNavigation: true, 
			loop: true,
		});	

  // Collapses used on News page
  const newsCollapses = document.querySelectorAll(".news-item");

  newsCollapses.forEach(function (e) {
    var newsBtn = e.querySelectorAll(".news-btn");
    var collapse = e.querySelector(".collapse");

    if (collapse) {
      collapse.addEventListener("show.bs.collapse", (event) => {
        if (newsBtn) {
          newsBtn.forEach(function (e) {
            e.innerHTML = "Read Less...";
            e.closest(".news-item-content").classList.toggle("open");
          });
        }
      });

      collapse.addEventListener("hide.bs.collapse", (event) => {
        if (newsBtn) {
          newsBtn.forEach(function (e) {
            e.innerHTML = "Read More...";
            e.closest(".news-item-content").classList.toggle("open");
          });
        }
      });
    }
  });


	var characterGallery = document.querySelector('.character-carousel');

	if(characterGallery){
	
		var characterCarousel = new Splide( '.character-carousel', {
			type       : 'loop',
      perPage    : 1,
			pagination : false,
			arrows     : true,
			cover      : true,
		}).mount();

	
		// Light box
		var lightbox = GLightbox({
			touchNavigation: true, 
			loop: true,
		});	

	}



});
